import React from 'react'
import Accordions from '../../../components/Accordions'


const Sem1IT1 = () => {
  const data = [
    {
      subjectName: "2023 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/17xRxYVQcoxQxTVD0LP1MTcqptX8Ivl8e/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
    {
      subjectName: "2024 Batch",
      units: [],
      links: [
        {
          url: "https://drive.google.com/file/d/1yE9bg6RSvTMvwpcGdGGDwji3vuFre5ST/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
            {
      subjectName: "2025 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1Yi01LgPvYj065ZvfYV2LgQmhEIep4ozK/view?usp=drive_link",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">IT Sem - 1</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem1IT1